module.exports = __webpack_public_path__ + "static/media/YF99_1.451a1395.jpg";